import React from 'react'
import { MenuItemType } from '@utils/types'
import { WImage, EditableTitle, EditableDescription, WLink } from '@components/atoms'
import styles from './CategoriaHubCard.module.sass'
import { ChevronRight } from '@components/icons'

interface Props {
  item: MenuItemType
  editMode?: boolean
  className?: string
}

const CategoriaHubCard = (props: Props) => {
  const { item = undefined, editMode = false, className = '' } = props

  return item ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <div className={`${styles.layout}`}>
        <div className={styles.left}>
          <div className={`${styles.imageBox}`}>
            {!!item.image && (
              <WImage
                src={item.image}
                maxWidth={100}
                maxHeight={100}
                alt={item.alt}
                title={item.alt}
              />
            )}
          </div>
          <div className={styles.main}>
            {(!!item.name || !!item.description) && (
              <div className={styles.content}>
                <EditableTitle
                  title={item.name}
                  variant="h3"
                  className={styles.title}
                  editMode={editMode}
                />
                <EditableDescription
                  description={item.description}
                  className={styles.description}
                  editMode={editMode}
                />
              </div>
            )}
          </div>
        </div>

        <WLink href={item.url ?? ''} ariaLabel={item.name} className={styles.iconBox}>
          <span className={styles.icon}>
            <ChevronRight />
          </span>
        </WLink>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default CategoriaHubCard
